import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const rejectPettyCashCommonRequest = createAsyncThunk(
	"rejectPettyCashCommonRequest",
	async ({ id, data }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put(`petty-cash/common-request/${id}/status`, data);
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	}
);

const PettyCashCommonRequestRejectSlice = createSlice({
	name: "PettyCashCommonRequestRejectSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetPettyCashCommonRequestRejectState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(rejectPettyCashCommonRequest.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(rejectPettyCashCommonRequest.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(rejectPettyCashCommonRequest.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashCommonRequestRejectState } = PettyCashCommonRequestRejectSlice.actions;
export default PettyCashCommonRequestRejectSlice.reducer;
